export const MAIN_API = "https://bored-toad-sweatshirt.cyclic.app";
